import React from 'react'

const IframeViewer = ({ link, title = 'Content' }) => {
	return (
		<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
			<div className="card-header border-bottom">
				<h5 className="mb-0">{title}</h5>
			</div>
			<div className="card-body p-0" style={{ height: '50vh' }}>
				{link ? (
					<iframe
						style={{
							width: '100%',
							height: '100%',
							border: 'none',
							overflow: 'auto'
						}}
						src={link}
						title={title}
					/>
				) : (
					<div className="d-flex justify-content-center align-items-center h-50">
						<div className="text-center">
							<i className="fa fa-clock-o text-muted mb-3" style={{ fontSize: '64px' }}></i>
							<h1 className="text-muted">Coming Soon</h1>
							<p className="text-muted">This content will be available soon</p>
						</div>
					</div>
				)}
			</div>
		</div>
	)
}

export { IframeViewer }
